import React, { useState } from 'react';

const CommonQuestionsPage = () => {
  const [openQuestion, setOpenQuestion] = useState(1);

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  const faqItems = [
    {
      id: 1,
      question: "What is the level of experience of the 24-7 Consultancy team?",
      answer: "Our expert team possesses over 30 years of collective industry experience (both healthcare and business ventures), and brings a wealth of knowledge and expertise to the table. Our mission is to serve and solve your service issues apart from our competitors. Our goal is to assist you in working more efficiently and taking your business to the next level."
    },
    {
      id: 2,
      question: "What are the advantages of partnering with 24-7 Consultancy?",
      answer: ""
    },
    {
      id: 3,
      question: "How does 24-7 Consultancy enhance business operations?",
      answer: ""
    },
    {
      id: 4,
      question: "How does 24-7 Consultancy ensure the confidentiality and security of client data?",
      answer: ""
    },
    {
      id: 5,
      question: "Do you provide references or case studies?",
      answer: ""
    },
    {
      id: 6,
      question: "How do you measure success?",
      answer: ""
    },
    {
      id: 7,
      question: "Do you work with clients located in different regions or countries?",
      answer: ""
    }
  ];

  const services = {
    bpo: [
      "Inbound Calls",
      "Outbound Calls",
      "Email and Chat Support",
      "SMS Support"
    ],
    healthCare: [
      "Medical Billing",
      "Medical Transcriptions",
      "Management Services"
    ],
    digitalMarketing: [
      "WEB Development",
      "Graphic Designing",
      "UI UX Designing",
      "Search Engine Optimization",
      "Social Media Marketing",
      "Content Writing"
    ]
  };

  return (
    <div className="bg-white min-h-screen">
      {/* Common Questions Section */}
      <div className="max-w-4xl mx-auto py-16 px-4">
        <h2 className="text-3xl font-bold text-center mb-2">Common <span className="text-cyan-500">Questions</span></h2>
        <p className="text-center text-gray-600 text-sm mb-8">
          Need help? We're here for you. Check out our Common Questions Section or send us a message via contact page. Thank you.
        </p>

        <div className="space-y-2">
          {faqItems.map((item) => (
            <div key={item.id} className="border border-gray-200 rounded-md overflow-hidden">
              <button
                className={`w-full flex items-center justify-between p-4 text-left ${openQuestion === item.id ? 'bg-cyan-500 text-white' : 'bg-gray-100 text-gray-700'}`}
                onClick={() => toggleQuestion(item.id)}
              >
                <div className="flex items-center">
                  <span className={`w-8 h-8 flex items-center justify-center rounded-full mr-3 ${openQuestion === item.id ? 'bg-white text-cyan-500' : 'bg-cyan-500 text-white'}`}>
                    {String(item.id).padStart(2, '0')}
                  </span>
                  <span>{item.question}</span>
                </div>
                <svg
                  className={`w-5 h-5 transition-transform ${openQuestion === item.id ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              {openQuestion === item.id && (
                <div className="p-4 bg-white">
                  <p className="text-gray-700">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Services Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">BPO</h3>
            <ul className="space-y-2">
              {services.bpo.map((service, index) => (
                <li key={index} className="text-gray-600 hover:text-cyan-500 transition-colors">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Health Care</h3>
            <ul className="space-y-2">
              {services.healthCare.map((service, index) => (
                <li key={index} className="text-gray-600 hover:text-cyan-500 transition-colors">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Digital Marketing</h3>
            <ul className="space-y-2">
              {services.digitalMarketing.map((service, index) => (
                <li key={index} className="text-gray-600 hover:text-cyan-500 transition-colors">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="w-5 h-5 mt-1 mr-2 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                <span className="text-gray-600">(051) 2116866</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 mt-1 mr-2 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <span className="text-gray-600">info@24-7consultancy.com</span>
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 mt-1 mr-2 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span className="text-gray-600">
                  Plot # 817/E, Ground Floor, Jl-Jaddad Business Centre, 5th Road, Adjacent to Iqbal Petrol Pump, Satellite Town, Rawalpindi.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-blue-900 text-white py-4">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm mb-4 md:mb-0">Copyrights © 2023 All Rights Reserved by 24-7 Consultancy</p>
          <div className="flex space-x-4">
            <a href="#" className="text-white hover:text-cyan-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"></path>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-cyan-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.523-4.477-10-10-10zm-3.11 8.03c.561-.258 1.152-.447 1.759-.561v.56c0 1.428.732 2.723 1.952 3.439-.372.139-.78.215-1.201.215-.323 0-.635-.043-.931-.12 1.011 1.001 2.365 1.615 3.863 1.634-1.414 1.107-3.17 1.757-5.096 1.757-.33 0-.66-.018-.979-.056 1.829 1.179 3.992 1.868 6.319 1.868 7.583 0 11.729-6.266 11.729-11.729 0-.178-.003-.355-.012-.531.803-.579 1.5-1.306 2.047-2.124-.732.322-1.525.546-2.357.636.848-.507 1.498-1.312 1.804-2.27-.792.467-1.672.81-2.605.992-.747-.797-1.815-1.293-2.995-1.293-2.269 0-4.093 1.823-4.093 4.093v.938c-3.349-.166-6.32-1.777-8.312-4.235-.344.595-.54 1.289-.54 2.025 0 1.42.724 2.679 1.824 3.415z"></path>
              </svg>
            </a>
            <a href="#" className="text-white hover:text-cyan-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.582 7.164a2.506 2.506 0 00-1.768-1.768C18.254 5 12 5 12 5s-6.254 0-7.814.396a2.506 2.506 0 00-1.768 1.768C2.036 8.726 2 10.334 2 12c0 1.666.036 3.274.418 4.836a2.506 2.506 0 001.768 1.768C5.746 19 12 19 12 19s6.254 0 7.814-.396a2.506 2.506 0 001.768-1.768C22 15.274 22 13.666 22 12c0-1.666-.037-3.274-.418-4.836zM9.955 15.076V8.924L15.5 12l-5.545 3.076z"></path>
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CommonQuestionsPage;